import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import styles from "../css/getStarted.module.css";
import ClientsReviews from "../components/ClientsReviews";
import Hero from "../containers/Hero";
import result from "../assets/images/icon-results.png";
import thumb from "../assets/images/thumb.png";
import support from "../assets/images/icon-package.png";

export default function Home() {
	const heroContent = (
		<>
			<h1 className="text-5xl font-bold">
				Grow and Upgrade <span className="text-pink-350">Your Online Presence</span> in Minutes
			</h1>
			<div className="flex flex-col gap-3 my-10">
				<p>Real Growth, Real Followers, Real Engagement.</p>
				<p>
					Unlock the full potential of your social profiles in just one day with the help of a
					trustworthy partner.
				</p>
			</div>
			<Link className={`my-5 md:ml-48 px-5 md:px-12 py-3 ${styles.getStarted}`} to="/getstarted">
				Get started
			</Link>
		</>
	);

	const strugglingSection = (
		<section className="container mx-auto my-20 px-5 md:px-20 lg:px-24 text-center">
			<h2 className="my-5 text-3xl font-bold">Struggling to Get Noticed Online?</h2>
			<div className="flex flex-col gap-3 mt-8">
				<p className="font-semibold">
					In a world overflowing with content, standing out from the herd and building a genuine
					following can feel like an uphill battle.
				</p>
				<p className="font-semibold">
					At Daily Social Boost, we provide a trustworthy solution to amplify your social media
					metrics—real followers, real likes, real views, real subscribers, real growth!
				</p>
				<p className="font-semibold">Because quality matters over quantity.</p>
				<p className="font-semibold">
					We guarantee growth with integrity, boosting your social media accounts without
					compromising on authenticity.
				</p>
			</div>
		</section>
	);

	const howItWorksSection = (
		<section className="container mx-auto mt-10 mb-20 px-0 md:px-20 lg:px-24 text-center">
			<h2 className="my-5 text-3xl font-bold pb-20">How It Works</h2>
			<div className="flex flex-col gap-3 mt-4">
				<div className="flex flex-row lg:flex-row max-sm:flex-col items-center">
					<div className="text-center my-0 max-sm:my-5 basis-full">
						<img className="mx-auto flex-none" src={thumb} alt="Delivery" />
						<h2 className="my-5 text-xl font-bold">Step 1</h2>
						<p className="mx-10">Choose a Platform - Instagram, TikTok, YouTube, Twitter.</p>
					</div>
					<div className="text-center my-0 max-sm:my-5 basis-full">
						<img
							className="mx-auto flex-none max-w-[100px] max-h-[110px]"
							src={result}
							alt="Guarantee"
						/>
						<h2 className="my-5 mx-5 text-xl font-bold">Step 2</h2>
						<p className="mx-10">
							Watch Your Social Media Grow - Real stats, real engagement, real success.
						</p>
					</div>
					<div className="text-center my-0 max-sm:my-5 basis-full">
						<img
							className="mx-auto flex-none  max-w-[100px] max-h-[110px]"
							src={support}
							alt="Support"
						/>
						<h2 className="my-5 text-xl font-bold">Step 3</h2>
						<p className="mx-10">Because quality matters over quantity.</p>
					</div>
				</div>
			</div>
		</section>
	);

	const whyChooseUseSection = (
		<section className="container mx-auto my-20 px-0 md:px-20 lg:px-24 text-center">
			<h2 className="my-5 text-3xl font-bold">Why Choose Us</h2>
			<div className="flex flex-col md:flex-row mt-8">
				<div className="flex flex-col gap-3 mt-8">
					<h3 className="text-xl font-bold">Verified Real User Engagement</h3>
					<p className="mx-10">
						We stand out by guaranteeing genuine engagement from real users across all platforms.
						Our process ensures that every follower, like, and view comes from actively engaged,
						authentic accounts.
					</p>
				</div>
				<div className="flex flex-col gap-3 mt-8">
					<h3 className="text-xl font-bold">Safety and Privacy First</h3>
					<p className="mx-10">
						Our services are designed to comply with the terms of service of each platform, ensuring
						that your account remains secure. With Daily Social Boost, you can be confident that
						your social media expansion is backed by rigorous security protocols, safeguarding your
						information and integrity.
					</p>
				</div>
				<div className="flex flex-col gap-3 mt-8">
					<h3 className="text-xl font-bold">Customized Growth Strategies</h3>
					<p className="mx-10">
						Recognizing that each social media journey is unique, we offer personalized growth plans
						tailored to your specific goals and audience. This bespoke approach ensures more
						meaningful engagement and long-lasting growth.
					</p>
				</div>
			</div>
		</section>
	);

	const successSection = (
		<section className="container mx-auto my-20 px-5 md:px-20 lg:px-24 text-center">
			<h2 className="my-5 text-3xl font-bold">Your Success is Our Success</h2>
			<div className="flex flex-col gap-3 mt-8">
				<p className="font-semibold">
					Transparency, reliability, and real results. That’s what makes us different.
				</p>
				<p className="font-semibold">
					Your success is our success and we’ll do anything to achieve it. With years of experience
					and a deep understanding of social media algorithms, our team at Daily Social Boost guides
					you through every step of your growth journey.
				</p>
			</div>
		</section>
	);

	return (
		<>
			<Helmet>
				<title>Dailysocialboost | Home</title>
			</Helmet>
			<section>
				<Hero>{heroContent}</Hero>
			</section>
			{strugglingSection}
			{howItWorksSection}
			{whyChooseUseSection}
			{successSection}
			<ClientsReviews />
		</>
	);
}
